var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("NotFound")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("ログイン画面へ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }